import { toast } from "sonner";

// Banner di benvenuto, mostrato a Home DOPO la copertina (per non rendere scattosa l'animazione).
// variant: "worker" (azzurro, default) | "office" (lilla).
export const welcomeToast = (name, variant = "worker") => {
  const styles = {
    worker: { background: "#EAF4FB", border: "1px solid #A9C7DD", color: "#22364D" },
    office: { background: "#EDEAF6", border: "1px solid #C4B7E6", color: "#4B3F7A" },
  };
  toast(name ? `Bentornato, ${name}!` : "Bentornato in Orbit!", {
    duration: 2600,
    icon: null,
    style: styles[variant] || styles.worker,
  });
};
